import { Modal } from 'antd';

// 与老项目 tos-web-front/src/utils/authFetch.ts 对齐：检测后端会话失效消息并强制重新登录
const SESSION_EXPIRED_MSGS = ['session not found or expired', 'get session not token'];

// 单例标志，防止同一时间并发多个接口失效时重复弹窗
let sessionExpiredModalShown = false;

/**
 * 检查响应 msg 是否为会话失效错误，命中则弹"登录状态已失效"模态并引导重新登录。
 * 返回 true 表示已接管，调用方应立即抛出错误中断当前请求。
 */
export function handleSessionExpiredMsg(msg: string | undefined): boolean {
  if (!msg || !SESSION_EXPIRED_MSGS.includes(msg)) return false;

  if (sessionExpiredModalShown) return true;
  sessionExpiredModalShown = true;

  Modal.warning({
    title: '登录状态已失效',
    content: '检测到您当前处于非登录态，请重新登录',
    okText: '重新登录',
    onOk: () => {
      // 保持 sessionExpiredModalShown = true 直到清理完毕，
      // 防止 toggleSeatStatus 调用失败时触发二次弹窗
      Promise.all([
        import('@/store/user/service'),
        import('@/store/mn/service'),
        import('@/utils/localStorage'),
      ]).then(async ([{ logout }, { toggleSeatStatus }, { getSeatId }]) => {
        // best-effort 释放驾舱（会话已失效时此调用大概率失败，静默处理）
        await toggleSeatStatus(getSeatId(), 0).catch(() => {});
        sessionExpiredModalShown = false;
        logout();
      });
    },
  });

  return true;
}
